import { h, Component } from 'preact'
import Header from '../../header'
import ButtonControl from '../../button-control'
import Icon from '../../assets'
import SimplePanel from '../../ui-components/SimplePanel'

type Props = {
}

type State = {
}

export class ProductUpdatesPlatform extends Component<Props, State> {
  render () {
    return (
      <div className='product-updates-platform-page'>
        <Header
          title='Product Updates'
          disableSaveButton
          disableCancelButton
          customButtons={[
            <a href='/product-update/overview' target='_blank'>
              <ButtonControl
                title={<div class='product-updates-overview-link'>Go to product updates overview page<Icon icon={'openInNew'} width={16} height={16} /></div>}
                variant='secondary'
                newStyle
                size='medium'
              />
            </a>
          ]}
        />
        <h2 className='panel-new__heading product-updates-platform-settings'>Setting</h2>
        <SimplePanel className='product-updates-platform-permissions-panel' image={<Icon icon='key' width={30} height={30} color='#0069FF' />}>
          <a className='product-updates-platform-permissions-link' href='/platform/product-updates/permissions' />
          <div class='product-updates-permissions__title'><h5>Permissions</h5></div>
          <div class='product-updates-permissions__description'>Manage visibility and reply permissions</div>
        </SimplePanel>
      </div>
    )
  }
}

export default ProductUpdatesPlatform
